import React from 'react';
import { Col, Form, InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import SoftBadge from 'components/common/SoftBadge';

const LeadTags = ({
    Modal_BitAddTag,
    setModal_BitAddTag,
    Modal_JsonTags,
    Modal_valueTagSelected,
    setModal_valueTagSelected,
    TagsForModalDDL,
    tags,
    actualizarJsonTags
}) => {
    return (
        <>
            <Col className="col-5">
                {Modal_BitAddTag ? (
                    <InputGroup className="fs--1 align-items-center">
                        <Form.Select
                            size="sm"
                            aria-label="Default select"
                            value={Modal_valueTagSelected}
                            onChange={(event) => {
                                const selectedValue = parseInt(event.target.value, 10);
                                setModal_valueTagSelected(selectedValue);

                                const objDDLTag = TagsForModalDDL.find(t => t.idLeadTag === selectedValue);

                                if (objDDLTag != null) {
                                    const objLeadTag = { idLeadTag: objDDLTag.idLeadTag };
                                    const copyModal_JsonTags = [...Modal_JsonTags];
                                    copyModal_JsonTags.push(objLeadTag);

                                    setModal_valueTagSelected(-1);
                                    actualizarJsonTags(copyModal_JsonTags, objDDLTag);
                                    setModal_BitAddTag(false);
                                }
                            }}
                        >
                            <option value="-1">Selecciona una Opción</option>
                            {TagsForModalDDL.map((tag, index) => {
                                if (tag.bIsActive == 1) {
                                    return (
                                        <option key={index} value={tag.idLeadTag}>
                                            {tag.vNombreTag}
                                        </option>
                                    );
                                }
                                return null;
                            })}
                        </Form.Select>

                        <button
                            onClick={() => setModal_BitAddTag(false)}
                            className="d-sm-block me-2 btn btn-falcon-default btn-sm"
                        >
                            x
                        </button>
                    </InputGroup>
                ) : (
                    <button
                        onClick={() => setModal_BitAddTag(true)}
                        className="d-sm-block me-2 btn btn-falcon-default btn-sm"
                    >
                        Agregar etiqueta
                    </button>
                )}
            </Col>
            <Col className="col-12 mb-3">
                {Modal_JsonTags.map((tag, index) => {
                    const objDDLTag = tags.find(t => t.idLeadTag == tag.idLeadTag);

                    if (!objDDLTag) return null;

                    return (
                        <span key={index}>
                            <SoftBadge
                                className={"me-3 bgTag_" + index}
                                bg={objDDLTag.colorActive}
                            >
                                {objDDLTag.vNombreTag}&nbsp;
                                <span
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        const copyModal_JsonTags = Modal_JsonTags.filter(
                                            item => item.idLeadTag !== objDDLTag.idLeadTag
                                        );
                                        actualizarJsonTags(copyModal_JsonTags, objDDLTag);
                                    }}
                                >
                                    ❌
                                </span>
                            </SoftBadge>
                        </span>
                    );
                })}
            </Col>
        </>
    );
};

LeadTags.propTypes = {
    Modal_BitAddTag: PropTypes.bool.isRequired,
    setModal_BitAddTag: PropTypes.func.isRequired,
    Modal_JsonTags: PropTypes.array.isRequired,
    Modal_valueTagSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setModal_valueTagSelected: PropTypes.func.isRequired,
    TagsForModalDDL: PropTypes.array.isRequired,
    tags: PropTypes.array.isRequired,
    actualizarJsonTags: PropTypes.func.isRequired
};

export default LeadTags;
